module.exports = {
      id: "default-image-usage",
      viewBox: "0 0 322 191",
      url: __webpack_public_path__ + "svg-sprite-6b422ea7dc08f55780ae3689062e9e73.svg#default-image",
      toString: function () {
        return this.url;
      }
    }